import { render, staticRenderFns } from "./CommentComponent.vue?vue&type=template&id=66e1e26a&scoped=true"
import script from "./CommentComponent.vue?vue&type=script&lang=ts"
export * from "./CommentComponent.vue?vue&type=script&lang=ts"
import style0 from "./CommentComponent.vue?vue&type=style&index=0&id=66e1e26a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e1e26a",
  null
  
)

export default component.exports